<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18px"
		height="20px"
		viewBox="0 0 18 20"
	>	
	<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
		<g transform="translate(-696.000000, -855.000000)" fill-rule="nonzero">
			<g transform="translate(687.000000, 848.000000)">
				<g transform="translate(8.996319, 7.038165)">
					<path
						d="M5.64542848,9.15823819 L6.44119122,9.95534528 C5.66606276,9.87757411 4.8653414,10.1144227 4.24609689,10.665891 L4.20458137,10.7042652 L1.66495891,13.2443382 C0.584094758,14.3253979 0.545492467,16.0540699 1.54915204,17.1813876 L1.66495891,17.3041069 C2.74587135,18.3851184 4.47430788,18.4237259 5.60147204,17.4199296 L5.65596229,17.3679211 L8.18261002,14.8414825 C8.81665861,14.2073192 9.09204988,13.3503032 9.00878382,12.5225531 L9.80841096,13.3219105 C9.71220019,14.0105641 9.42284529,14.6597967 8.97209784,15.1928009 L8.94303096,15.2378229 L8.90138939,15.2853785 L6.26496552,17.9217049 L6.16420653,18.01918 C6.14336929,18.040448 6.12078274,18.0589634 6.0968997,18.0747216 C5.43064339,18.6467397 4.578741,18.9634206 3.6945668,18.9618293 C1.65825625,18.9638936 0.00579850979,17.3146126 0.00368247887,15.2780246 C0.00280166917,14.4006974 0.314530417,13.55531 0.87726884,12.8908955 L0.905449287,12.8468935 L0.946179545,12.8004422 L3.6833624,10.0666406 C3.70419964,10.0453727 3.72678619,10.0268572 3.75066923,10.011099 C4.28802302,9.54962958 4.94654657,9.25425716 5.64542848,9.15823819 Z M9.26258261,10.1391913 C9.43330593,10.3098725 9.45232233,10.5748654 9.31959969,10.7665564 L9.26271587,10.8346771 L6.13965125,13.9593646 C5.94766112,14.1514545 5.63632394,14.1515142 5.44426021,13.9594979 C5.27353689,13.7888167 5.25452049,13.5238238 5.38724313,13.3321328 L5.44412695,13.2640121 L8.56719157,10.1393246 C8.7591817,9.94723472 9.07051888,9.94717505 9.26258261,10.1391913 Z M13.080905,6.31888479 C13.2516283,6.48956594 13.2706447,6.75455883 13.1379221,6.94624984 L13.0810383,7.01437057 L11.0741915,8.98069714 C10.8822014,9.17278704 10.5708642,9.17284671 10.3788005,8.98083042 C10.2080772,8.81014927 10.1890608,8.54515638 10.3217834,8.35346537 L10.3786672,8.28534464 L12.385514,6.31901807 C12.5775041,6.12692817 12.8888413,6.1268685 13.080905,6.31888479 Z M14.3127963,0.961841235 C16.3491068,0.959770853 18.0015646,2.6090519 18.0036787,4.64563987 C18.0045614,5.52296708 17.6928327,6.36835448 17.1300943,7.03276896 C17.1136507,7.06313043 17.0924094,7.0915294 17.0670359,7.1174192 L14.4633995,9.72146033 L14.3240007,9.85702388 C14.3031635,9.87829181 14.2805769,9.89680723 14.2566939,9.91256547 C13.7193401,10.3740349 13.0608165,10.6694073 12.3619346,10.7654263 L11.5661719,9.96831919 C12.3413003,10.0460904 13.1420217,9.80924178 13.7612662,9.25777344 L13.8027817,9.21939923 L16.3424042,6.67932632 C17.4232683,5.59826662 17.4618706,3.86959461 16.4582111,2.74227689 L16.3424042,2.61955753 C15.2614917,1.53854612 13.5330552,1.49993857 12.4058911,2.50373487 L12.3514008,2.5557434 L9.82475308,5.082182 C9.19070449,5.7163453 8.91531322,6.57336132 8.99857927,7.40111135 L8.19895213,6.60175402 C8.2951629,5.91310037 8.58451781,5.26386781 9.03526526,4.73086354 C9.05236137,4.6999148 9.07406211,4.67067864 9.10012139,4.64408911 L11.7815368,1.96449853 L11.8431566,1.90448444 C11.8639938,1.88321651 11.8865804,1.86470109 11.9104634,1.84894284 C12.5767197,1.27692477 13.4286221,0.960243832 14.3127963,0.961841235 Z"
						:fill="color"
					/>
					<path
						d="M1.14657408,2.10481293 C1.31595034,1.93537893 1.57889199,1.91653147 1.76908408,2.04828517 L1.83667115,2.10475227 L16.8607265,17.1286465 C17.0513083,17.3192263 17.0513355,17.6282443 16.8607872,17.8188575 C16.6914109,17.9882915 16.4284692,18.007139 16.2382772,17.8753853 L16.1706901,17.8189182 L1.14663473,2.79502392 C0.956052936,2.60444417 0.95602578,2.29542618 1.14657408,2.10481293 Z"
						:fill="color"
					/>
				</g>
			</g>
		</g>
	</g>
</svg>

</template>

<script>
export default {
	/**
	 * name
	 */
	name: 'iconUnlink',

	/**
	 * props
	 */
	props: {
		color: {
			default: 'currentColor'
		},
		width: {
			default: 18
		},
		height: {
			default: 20
		}
	}
};
</script>
